import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ConsumoEditarRoutingModule } from './consumo-editar-routing.module';
import { ConsumoEditarComponent } from './consumo-editar.component';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { DividerModule } from 'primeng/divider';
import { MessagesModule } from 'primeng/messages';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { InputNumberModule } from 'primeng/inputnumber';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ConfirmationService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';


@NgModule({
  declarations: [
    ConsumoEditarComponent
  ],
  imports: [
    CommonModule,
    ConsumoEditarRoutingModule,
    FormsModule,
    TableModule,
    DialogModule,
    InputTextModule,
    DividerModule,
    MessagesModule,
    DropdownModule,
    CalendarModule,
    InputNumberModule,
    ProgressSpinnerModule,
    ConfirmDialogModule
  ],
  providers: [ConfirmationService]
})
export class ConsumoEditarModule { }
